import { safeDefine } from "../../registration/safe-define.js";
import { ControlsElement } from "../../ui/controls/element.js";
//#region src/define/ui/controls.ts
safeDefine(ControlsElement);
//#endregion
